import { Actions, ActionTypes } from '../actions/auth';
import { User } from '../../lib/classes/user';

export interface State {
  showProgressBar: boolean;
}

export function clearState(reducer) {
  return function(state, action) {
    if (action.type === ActionTypes.Logout) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export interface UserState {
  currentUser: User;
}

const initialState: UserState = {
  currentUser: null,
};

export function authReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case ActionTypes.CurrentUserLoaded:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
